import React from "react";
import { Row, Col ,MenuItem ,DropdownButton ,ButtonToolbar,Button,Grid,ToggleButtonGroup,ToggleButton } from 'react-bootstrap'
import ProductItem from "../ProductItem/ProductItem";
class ListProducts extends React.Component {
render() {
return (
    <div className="ListProducts">
        
          

            <Row>
              <Col md={12}>
       <ProductItem/>
       </Col>
       <Col md={12}>
       <ProductItem/>
       </Col>
       <Col md={12}>
       <ProductItem/>
       </Col>
       <Col md={12}>
       <ProductItem/>
       </Col>

          <Col md={12}>
       <ProductItem/>
       </Col>
       <Col md={12}>
       <ProductItem/>
       </Col>
       <Col md={12}>
       <ProductItem/>
       </Col>
       <Col md={12}>
       <ProductItem/>
       </Col>

       <Col md={12}>
       <ProductItem/>
       </Col>
        <Col md={12}>
       <ProductItem/>
       </Col>
       
       
       
       
     
        
        </Row>


    </div>
  

);
}
}
export default ListProducts;


// WEBPACK FOOTER //
// ./src/Components/ListProducts/ListProducts.jsx